"use strict";
exports["75fcb70a"] = validate10;
const schema11 = {"$schema":"http://json-schema.org/draft-07/schema","type":"object","title":"WizSmtpOutboundTitleText","properties":{"outboundIPAddress":{"type":"string","title":"LabelOutboundIPAddress","pattern":"(?!(^172\\.((1[6-9])|(2\\d)|(3[0-1]))(\\.\\d{1,3}){2}$|^10(\\.\\d{1,3}){3}$|^192\\.168(\\.\\d{1,3}){2}$))(^(([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.){3}([01]?\\d\\d?|25[0-5]|2[0-4]\\d)$)|(^([0-9a-fA-F]{4}(::)?){8}$)"},"performReverseDnsCheck":{"type":"boolean","title":"LabelPerformReverseDNS","default":true},"performRBLCheck":{"type":"boolean","title":"LabelPerformRBL","default":true},"performSenderIdCheck":{"type":"boolean","title":"LabelPerformSenderId","default":true},"proofOfWork":{"type":"string","title":""}},"required":["outboundIPAddress","proofOfWork"],"dependencies":{"performSenderIdCheck":{"oneOf":[{"properties":{"performSenderIdCheck":{"enum":[true]},"outboundEmailAddress":{"type":"string","title":"LabelEmailAddress","pattern":"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"}},"required":["outboundEmailAddress"]},{"properties":{"performSenderIdCheck":{"enum":[false]}}}]}},"$id":"75fcb70a"};
const pattern0 = new RegExp("^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$", "u");
const pattern1 = new RegExp("(?!(^172\\.((1[6-9])|(2\\d)|(3[0-1]))(\\.\\d{1,3}){2}$|^10(\\.\\d{1,3}){3}$|^192\\.168(\\.\\d{1,3}){2}$))(^(([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.){3}([01]?\\d\\d?|25[0-5]|2[0-4]\\d)$)|(^([0-9a-fA-F]{4}(::)?){8}$)", "u");

function validate10(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="75fcb70a" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.outboundIPAddress === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "outboundIPAddress"},message:"must have required property '"+"outboundIPAddress"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.proofOfWork === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "proofOfWork"},message:"must have required property '"+"proofOfWork"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.performSenderIdCheck !== undefined){
const _errs2 = errors;
let valid1 = false;
let passing0 = null;
const _errs3 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.outboundEmailAddress === undefined){
const err2 = {instancePath,schemaPath:"#/dependencies/performSenderIdCheck/oneOf/0/required",keyword:"required",params:{missingProperty: "outboundEmailAddress"},message:"must have required property '"+"outboundEmailAddress"+"'",schema:schema11.dependencies.performSenderIdCheck.oneOf[0].required,parentSchema:schema11.dependencies.performSenderIdCheck.oneOf[0],data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.performSenderIdCheck !== undefined){
let data0 = data.performSenderIdCheck;
if(!(data0 === true)){
const err3 = {instancePath:instancePath+"/performSenderIdCheck",schemaPath:"#/dependencies/performSenderIdCheck/oneOf/0/properties/performSenderIdCheck/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.performSenderIdCheck.oneOf[0].properties.performSenderIdCheck.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.performSenderIdCheck.oneOf[0].properties.performSenderIdCheck.enum,parentSchema:schema11.dependencies.performSenderIdCheck.oneOf[0].properties.performSenderIdCheck,data:data0};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.outboundEmailAddress !== undefined){
let data1 = data.outboundEmailAddress;
if(typeof data1 === "string"){
if(!pattern0.test(data1)){
const err4 = {instancePath:instancePath+"/outboundEmailAddress",schemaPath:"#/dependencies/performSenderIdCheck/oneOf/0/properties/outboundEmailAddress/pattern",keyword:"pattern",params:{pattern: "^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"},message:"must match pattern \""+"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$"+"\"",schema:"^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9-]+\\.)+[a-zA-Z0-9-]+$",parentSchema:schema11.dependencies.performSenderIdCheck.oneOf[0].properties.outboundEmailAddress,data:data1};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/outboundEmailAddress",schemaPath:"#/dependencies/performSenderIdCheck/oneOf/0/properties/outboundEmailAddress/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.dependencies.performSenderIdCheck.oneOf[0].properties.outboundEmailAddress.type,parentSchema:schema11.dependencies.performSenderIdCheck.oneOf[0].properties.outboundEmailAddress,data:data1};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
}
var _valid0 = _errs3 === errors;
if(_valid0){
valid1 = true;
passing0 = 0;
}
const _errs7 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.performSenderIdCheck !== undefined){
let data2 = data.performSenderIdCheck;
if(!(data2 === false)){
const err6 = {instancePath:instancePath+"/performSenderIdCheck",schemaPath:"#/dependencies/performSenderIdCheck/oneOf/1/properties/performSenderIdCheck/enum",keyword:"enum",params:{allowedValues: schema11.dependencies.performSenderIdCheck.oneOf[1].properties.performSenderIdCheck.enum},message:"must be equal to one of the allowed values",schema:schema11.dependencies.performSenderIdCheck.oneOf[1].properties.performSenderIdCheck.enum,parentSchema:schema11.dependencies.performSenderIdCheck.oneOf[1].properties.performSenderIdCheck,data:data2};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
}
var _valid0 = _errs7 === errors;
if(_valid0 && valid1){
valid1 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid1 = true;
passing0 = 1;
}
}
if(!valid1){
const err7 = {instancePath,schemaPath:"#/dependencies/performSenderIdCheck/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf",schema:schema11.dependencies.performSenderIdCheck.oneOf,parentSchema:schema11.dependencies.performSenderIdCheck,data};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
else {
errors = _errs2;
if(vErrors !== null){
if(_errs2){
vErrors.length = _errs2;
}
else {
vErrors = null;
}
}
}
}
if(data.outboundIPAddress !== undefined){
let data3 = data.outboundIPAddress;
if(typeof data3 === "string"){
if(!pattern1.test(data3)){
const err8 = {instancePath:instancePath+"/outboundIPAddress",schemaPath:"#/properties/outboundIPAddress/pattern",keyword:"pattern",params:{pattern: "(?!(^172\\.((1[6-9])|(2\\d)|(3[0-1]))(\\.\\d{1,3}){2}$|^10(\\.\\d{1,3}){3}$|^192\\.168(\\.\\d{1,3}){2}$))(^(([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.){3}([01]?\\d\\d?|25[0-5]|2[0-4]\\d)$)|(^([0-9a-fA-F]{4}(::)?){8}$)"},message:"must match pattern \""+"(?!(^172\\.((1[6-9])|(2\\d)|(3[0-1]))(\\.\\d{1,3}){2}$|^10(\\.\\d{1,3}){3}$|^192\\.168(\\.\\d{1,3}){2}$))(^(([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.){3}([01]?\\d\\d?|25[0-5]|2[0-4]\\d)$)|(^([0-9a-fA-F]{4}(::)?){8}$)"+"\"",schema:"(?!(^172\\.((1[6-9])|(2\\d)|(3[0-1]))(\\.\\d{1,3}){2}$|^10(\\.\\d{1,3}){3}$|^192\\.168(\\.\\d{1,3}){2}$))(^(([01]?\\d\\d?|2[0-4]\\d|25[0-5])\\.){3}([01]?\\d\\d?|25[0-5]|2[0-4]\\d)$)|(^([0-9a-fA-F]{4}(::)?){8}$)",parentSchema:schema11.properties.outboundIPAddress,data:data3};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/outboundIPAddress",schemaPath:"#/properties/outboundIPAddress/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.outboundIPAddress.type,parentSchema:schema11.properties.outboundIPAddress,data:data3};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.performReverseDnsCheck !== undefined){
let data4 = data.performReverseDnsCheck;
if(typeof data4 !== "boolean"){
const err10 = {instancePath:instancePath+"/performReverseDnsCheck",schemaPath:"#/properties/performReverseDnsCheck/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.performReverseDnsCheck.type,parentSchema:schema11.properties.performReverseDnsCheck,data:data4};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.performRBLCheck !== undefined){
let data5 = data.performRBLCheck;
if(typeof data5 !== "boolean"){
const err11 = {instancePath:instancePath+"/performRBLCheck",schemaPath:"#/properties/performRBLCheck/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.performRBLCheck.type,parentSchema:schema11.properties.performRBLCheck,data:data5};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.performSenderIdCheck !== undefined){
let data6 = data.performSenderIdCheck;
if(typeof data6 !== "boolean"){
const err12 = {instancePath:instancePath+"/performSenderIdCheck",schemaPath:"#/properties/performSenderIdCheck/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.performSenderIdCheck.type,parentSchema:schema11.properties.performSenderIdCheck,data:data6};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.proofOfWork !== undefined){
let data7 = data.proofOfWork;
if(typeof data7 !== "string"){
const err13 = {instancePath:instancePath+"/proofOfWork",schemaPath:"#/properties/proofOfWork/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.proofOfWork.type,parentSchema:schema11.properties.proofOfWork,data:data7};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.type,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
validate10.errors = vErrors;
return errors === 0;
}

exports["-49829668"] = validate11;
const schema12 = {"type":"object","properties":{"performSenderIdCheck":{"enum":[true]}},"$id":"-49829668"};

function validate11(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-49829668" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.performSenderIdCheck !== undefined){
let data0 = data.performSenderIdCheck;
if(!(data0 === true)){
const err0 = {instancePath:instancePath+"/performSenderIdCheck",schemaPath:"#/properties/performSenderIdCheck/enum",keyword:"enum",params:{allowedValues: schema12.properties.performSenderIdCheck.enum},message:"must be equal to one of the allowed values",schema:schema12.properties.performSenderIdCheck.enum,parentSchema:schema12.properties.performSenderIdCheck,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema12.type,parentSchema:schema12,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate11.errors = vErrors;
return errors === 0;
}

exports["-2203c2d9"] = validate12;
const schema13 = {"type":"object","properties":{"performSenderIdCheck":{"enum":[false]}},"$id":"-2203c2d9"};

function validate12(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-2203c2d9" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.performSenderIdCheck !== undefined){
let data0 = data.performSenderIdCheck;
if(!(data0 === false)){
const err0 = {instancePath:instancePath+"/performSenderIdCheck",schemaPath:"#/properties/performSenderIdCheck/enum",keyword:"enum",params:{allowedValues: schema13.properties.performSenderIdCheck.enum},message:"must be equal to one of the allowed values",schema:schema13.properties.performSenderIdCheck.enum,parentSchema:schema13.properties.performSenderIdCheck,data:data0};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema13.type,parentSchema:schema13,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate12.errors = vErrors;
return errors === 0;
}
